import { createStore } from 'zustand/vanilla';

import ReplaceUtils from '@MP/shared/utils/ReplaceUtils';

import { isValidPassword } from '../utils/passwordValidation';

export interface FindPasswordState {
  email: string;
  name: string;
  phoneNumber: string;
  certNumber: string;
  certId: number | null;
  certOK: boolean | null;
  password: string;
  confirmPassword: string;
  setEmail: (email: string) => void;
  setName: (name: string) => void;
  setPhoneNumber: (phoneNumber: string) => void;
  setCertNumber: (certNumber: string) => void;
  setCertId: (certId: number | null) => void;
  setCertOK: (ok: boolean | null) => void;
  setPassword: (pw: string, confirm: string) => void;
}

export const createFindPasswordStore = () =>
  createStore<FindPasswordState>((set, get) => ({
    email: '',
    name: '',
    phoneNumber: '',
    certNumber: '',
    certId: null,
    certOK: null,
    password: '',
    confirmPassword: '',
    setEmail: (email) => set({ email: email.trim() }),
    setName: (name) => {
      set({ name: name.trim() });
      get().setCertId(null);
      get().setCertOK(null);
    },
    setPhoneNumber: (phoneNumber) => {
      set({ phoneNumber: ReplaceUtils.replaceNumber(phoneNumber) });
      get().setCertId(null);
      get().setCertOK(null);
    },
    setCertNumber: (certNumber) => {
      set({ certNumber: ReplaceUtils.replaceNumber(certNumber) });
      get().setCertOK(null);
    },
    setCertId: (certId) => set({ certId }),
    setCertOK: (ok) => set({ certOK: ok }),
    setPassword: (pw, confirm) => set({ password: pw.trim(), confirmPassword: confirm.trim() }),
  }));

export type FindPasswordStoreApi = ReturnType<typeof createFindPasswordStore>;

export const selectIsPossibleReset = (s: FindPasswordState): boolean =>
  !!s.email &&
  !!s.certId &&
  !!s.certNumber &&
  !!s.certOK &&
  isValidPassword(s.password) &&
  s.password === s.confirmPassword;

export const selectResetBody = (s: FindPasswordState) => ({
  email: s.email,
  id: s.certId!,
  code: s.certNumber,
  password: s.password,
});
